// extracted by mini-css-extract-plugin
export var blue_divider = "index-module--blue_divider--73uSG";
export var career_page_container = "index-module--career_page_container--jYamB";
export var list = "index-module--list--h5TBU";
export var page_title = "index-module--page_title--X+kMT";
export var team_role = "index-module--team_role--HNV9Y";
export var team_title = "index-module--team_title--+yFuU";